{
  /* split into new line after each period '.' */
}
const MultipleLinesContent = ({ text }: { text: string }) => {
  const splitText = text?.split('.');
  return (
    <>
      {splitText?.length > 1
        ? splitText
            .filter((line) => line)
            .map((line, index) => <div key={`line-${index}`}>{line}.</div>)
        : text}
    </>
  );
};

export default MultipleLinesContent;
